// extracted by mini-css-extract-plugin
module.exports = {"table":"formula_table__2lEkz"};